import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccaBoostIconDirective } from './acca-boost-icon.directive';
import { AccaBoostRatioPipe } from './acca-boost-ratio.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [AccaBoostRatioPipe, AccaBoostIconDirective],
    exports: [AccaBoostRatioPipe, AccaBoostIconDirective],
})
export class AccaBoostBaseModule {}
